import { useState, useCallback } from "react";
import { UrlApi } from "../../../services/apirest";
import axios from "axios";

export const useFileUploadMP = () => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  /**
   * Sube uno o varios archivos al servidor usando una petición POST.
   *
   * @function
   * @async
   * @param {FileList|File[]} fileList - Lista de archivos a subir.
   * @param {string} tipo - Tipo de documento o categoría del archivo.
   * @param {string|number} fileId - Identificador único relacionado con la subida.
   * @returns {Promise<void|null>} Retorna void si la subida es exitosa, o null si ocurre un error.
   *
   * @example
   * // Ejemplo de uso en un componente React:
   * const handleUpload = async (event) => {
   *   const files = event.target.files;
   *   await uploadFile(files, "factura", "uuid");
   * };
   */
  const uploadFile = useCallback(async (fileList, tipo, fileId) => {
    setIsUploading(true);
    setUploadError(null);
    setUploadProgress(0);

    const formData = new FormData();
    formData.append("uid", fileId);
    formData.append("tipo", tipo);
    for (let i = 0; i < fileList.length; i++) {
      formData.append("archivo", fileList[i]);
    }

    try {
      const { data } = await axios.post(
        `${UrlApi}/mp_documentacion/upload`,
        formData,
        {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted);
          },
        }
      );
      setUploadProgress(100);
      return data; // {status:true , message :"Se guardaron los archivos correctamente"}
    } catch (error) {
      setUploadError(error.message || "Error al subir archivo");
      return null;
    } finally {
      setIsUploading(false);
      // Opcional: permitir que el componente decida cuándo resetear el progreso
      // setTimeout(() => setUploadProgress(0), 1000);
    }
  }, []);

  return {
    uploadFile,
    uploadProgress,
    isUploading,
    uploadError,
  };
};
